import { DOCUMENT, Inject, Injectable, makeStateKey, TransferState } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { map, shareReplay, tap } from 'rxjs/operators';

import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root',
})
export class IconService {

  private cache = new Map<string, Observable<SafeHtml>>();

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    @Inject(DOCUMENT) private document: Document,
    private transferState: TransferState,
    private platformService: PlatformService
  ) {}

  getIcon(name: string): Observable<SafeHtml> {

    const iconKey = makeStateKey<string>(`icon-${name}`);

    if (this.transferState.hasKey(iconKey)) {
      let cachedIcon = this.transferState.get(iconKey, '');
      const trustedIcon = this.sanitizer.bypassSecurityTrustHtml(cachedIcon)
      return of(trustedIcon);
    }

    if (!this.cache.has(name)) {
      const icon$ = this.httpClient
        .get(`/assets/mdi/${name}.svg`, { responseType: 'text' })
        .pipe(
          map((value) => {
            const div = this.document.createElement('div');
            div.innerHTML = value;
            const icon = div.firstChild! as HTMLElement;
            icon.setAttribute('height', '1em');
            icon.setAttribute('width', '1em');
            icon.setAttribute('fill', 'currentcolor');
            return div.innerHTML;
          }),
          tap((icon) => {
            if (!this.platformService.isBrowser) {
              this.transferState.set(iconKey, icon as any);
            }
          }),
          map(i => {
            return this.sanitizer.bypassSecurityTrustHtml(i);
          }),
          shareReplay(1) // Ensure the HTTP request is made only once
        );

      this.cache.set(name, icon$);
    }

    return this.cache.get(name)!;
  }
}

